module.exports = __webpack_public_path__ + "img/waiting.e8159feb.svg";